<template>
    <div>
                <!--ROBA-ES und smartflex-->
        <div v-if="productSizes.gruppen[0].arten[0].art == ''">
            <div class="col-md-12 header-sizes p-0 mt-2">
                    <b-card-header header-tag="header" class="p-2">
                        <span>{{$t('direct-entry.size')}}</span>
                        <p class="float-right mb-0">{{$t('direct-entry.chooseProduct')}}</p>
                    </b-card-header>
            </div>
            <div class="row rowBorder" v-for="gruppe in productSizes.gruppen" :key="gruppe.arten.sizes" >
                <div id="wrapper" v-for="arten in gruppe.arten" :key="arten.art">
                    <div class="row">
                        <div class="col-6 col-sm-6 col-md-4 " v-for="size in arten.sizes" :key="size.size">
                            <div class="box-sizing selection" @click="searchByMaxStklId(size.maxstklId)" :title="$t('product-list.configureModelTooltip')">
                                <h4>{{$t('tree-children.size')}} {{size.size}}</h4>
                                <span>{{size.maxDrehmoment}}</span><br>
                                <span>{{size.maxRPM}}</span><br>
                                <span>∅ {{size.durchmesser}}</span><br>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--ROBA-DS Servokupplung-->
        <div class="row border ml-0 mr-0 mt-2" v-if="productSizes.gruppen[0].arten[0].art != ''">
            <div class="col-md-12 pr-0 pl-0">
                <b-card-header header-tag="header" class="p-2">
                    <span><b>{{$t('product-sizes.title')}}</b></span>
                    <button class="btn direct-access-btn dropdown-toggle float-right pt-0 pr-2"
                            style="color: #337ab7"
                            v-b-toggle="'collapse-' + 1"></button>
                </b-card-header>
                <b-collapse :id="'collapse-' + 1" class="mt-2 pl-3 pr-3 mb-3">
                    <b-card-header header-tag="header" class="p-2 mt-2">
                        <p class="card-text"><b>{{$t('product-sizes.singleJointed')}}</b></p>
                        <span>{{$t('direct-entry.size')}}</span>
                        <span class="float-right">{{$t('direct-entry.chooseProduct')}}</span>
                    </b-card-header>
                    <div class="row rowBorder" v-for="gruppe in productSizes.gruppen" :key="gruppe.arten.sizes">
                        <div v-for="arten in gruppe.arten" :key="arten.art">
                            <div class="row">
                                <div class="col-6 col-sm-6 col-md-4"  v-for="size in arten.sizes" :key="size.size">
                                    <div v-if="arten.art == 'Eingelenkkupplung' && gruppe.name == 'Servokupplung'"
                                         class="col-12 col-sm-12 col-md-12 box-sizing selection"
                                         @click="searchByMaxStklId(size.maxstklId)" :title="gruppe.name">
                                        <h4>{{$t('tree-children.size')}} {{size.size}}</h4>
                                        <span>{{size.maxDrehmoment}}</span><br>
                                        <span>{{size.maxRPM}}</span><br>
                                        <span>∅ {{size.durchmesser}}</span><br>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <b-card-header header-tag="header" class="p-2 mt-2">
                        <p class="card-text"><b>{{$t('product-sizes.doubleJointed')}}</b></p>
                        <span>{{$t('direct-entry.size')}}</span>
                        <span class="float-right">{{$t('direct-entry.chooseProduct')}}</span>
                    </b-card-header>
                    <div class="row rowBorder" v-for="gruppe in productSizes.gruppen" :key="gruppe.arten.sizes">
                        <div v-for="arten in gruppe.arten" :key="arten.art">
                            <div class="row">
                                <div class="col-6 col-sm-6 col-md-4" v-for="size in arten.sizes" :key="size.size">
                                    <div v-if="arten.art == 'Zweigelenkkupplung' && gruppe.name == 'Servokupplung'"
                                         class="col-12 col-md-12 box-sizing selection"
                                         @click="searchByMaxStklId(size.maxstklId)" :title="gruppe.name">
                                        <h4>{{$t('tree-children.size')}} {{size.size}}</h4>
                                        <span>{{size.maxDrehmoment}}</span><br>
                                        <span>{{size.maxRPM}}</span><br>
                                        <span>∅ {{size.durchmesser}}</span><br>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-collapse>
            </div>
        </div>


        <!-- ROBA-DS Ganzstahlkupplung -->
        <div class="row border ml-0 mr-0 mt-2" v-if="productSizes.gruppen[0].arten[0].art != ''">
            <div class="col-md-12 pr-0 pl-0">
                <b-card-header header-tag="header" class="p-2">
                    <span><b>{{$t('product-sizes.secondTitle')}}</b></span>
                    <button class="btn direct-access-btn dropdown-toggle float-right pt-0 pr-2"
                            style="color: #337ab7"
                            v-b-toggle="'collapse-' + 2"
                            @click="setProductSizesArrays()"></button>
                </b-card-header>
                <b-collapse :id="'collapse-' + 2" class="mt-2 pl-3 pr-3 mb-3">

                    <!-- ROBA-DS Ganzstahlkupplung Eingelenk -->
                    <b-card-header header-tag="header" class="p-2 mt-2">
                        <p class="card-text"><b>{{$t('product-sizes.singleJointed')}}</b></p>
                        <span>{{$t('direct-entry.size')}}</span>
                        <span class="float-right">{{$t('direct-entry.chooseProduct')}}</span>
                    </b-card-header>
                    <!-- ROBA-DS Ganzstahlkupplung EingelenkHF -->
                    <ProductSizesRows :sizes="eingelenkHF" :lamellenpaket="'HF'"/>
                    <!-- ROBA-DS Ganzstahlkupplung EingelenkHT -->
                    <ProductSizesRows :sizes="eingelenkHT" :lamellenpaket="'HT'"/>

                    <!--ROBA-DS Ganzstahlkupplung Zweigelenk-->
                    <b-card-header header-tag="header" class="p-2 mt-2">
                        <p class="card-text"><b>{{$t('product-sizes.doubleJointed')}}</b></p>
                        <span>{{$t('direct-entry.size')}}</span>
                        <span class="float-right">{{$t('direct-entry.chooseProduct')}}</span>
                    </b-card-header>
                    <!-- ROBA-DS Ganzstahlkupplung ZweigelenkHF -->
                    <ProductSizesRows :sizes="zweigelenkHF" :lamellenpaket="'HF'"/>
                    <!-- ROBA-DS Ganzstahlkupplung ZweigelenkHT -->
                    <ProductSizesRows :sizes="zweigelenkHT" :lamellenpaket="'HT'"/>

                </b-collapse>
            </div>
        </div>

    </div>
</template>

<script>

    import ProductSizesRows from "./ProductSizesRows";
    import searchByMaxStklId from '../../mixins/searchByMaxStklId';

    export default {
        name: "ProductSizes",
        components: {ProductSizesRows},
        mixins: [searchByMaxStklId],
        data: function () {
            return {
                eingelenkHF: [],
                eingelenkHT: [],
                zweigelenkHF: [],
                zweigelenkHT: [],
            };
        },
        created() {
            this.setProductSizesArrays();
        },
        computed: {
            productSizes: function () {
                return this.$store.getters.productSizes;
            },
        },
        methods: {
            setProductSizesArrays() {
                let gruppen = this.productSizes.gruppen;
                for(let arten of gruppen){
                    for(let art of arten.arten){
                        if(art.art == 'eingelenkHF'){
                            this.eingelenkHF = art.sizes;
                        }
                        if(art.art == 'eingelenkHT'){
                            this.eingelenkHT = art.sizes;
                        }
                        if(art.art == 'zweigelenkHF'){
                            this.zweigelenkHF = art.sizes;
                        }
                        if(art.art == 'zweigelenkHT') {
                            this.zweigelenkHT = art.sizes;
                        }
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .box-sizing {
        margin-left: 0px;
        padding: 15px
    }
    .selection { cursor: pointer;}

    .header-sizes {
        margin-top: 15px;
        font-size: 16px;
    }

    .rowBorder {
        border-left: 1px solid #dee2e6;
        border-right: 1px solid #dee2e6;
        border-bottom: 1px solid #dee2e6;
        margin: 0px;
    }
</style>